import { render, staticRenderFns } from "./DelegatesEditPage.vue?vue&type=template&id=6394b4b6"
import script from "./DelegatesEditPage.vue?vue&type=script&lang=ts"
export * from "./DelegatesEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports